import './OrderStatus.css'

function OrderProducts() {
    return (
        <div className='product-lines-container'>
            <div className='product-line'>
                <section className="image-line" style={{backgroundImage: `url(${"img/5950x.jpg"})`}}></section>
                <div className='dati-line'> 
                    <div>Descrizione: AMD Ryzen 9 7950X3D processore 4,2 GHz 128 MB L3 Scatola</div>
                    <div>Codice fornitore: VLX0B17715</div>
                    <div>Codice produttore: 100-100000908WOF</div>
                    <div>Prezzo: 581 €</div>
                    <div>Quantità: 1</div>
                </div>
            </div>
            <div className='product-line'>
                <section className="image-line" style={{backgroundImage: `url(${"img/mobo.jpg"})`}}></section>
                <div className='dati-line'> 
                    <div>Descrizione: Asrock X670E PG LIGHTNING AMD X670 Presa di corrente AM5 ATX</div>
                    <div>Codice fornitore: VLX0AE5533</div>
                    <div>Codice produttore: 90-MXBJ60-A0UAYZ</div>
                    <div>Prezzo: 282 €</div>
                    <div>Quantità: 1</div>
                </div>
            </div>
            <div className='product-line'>
                <section className="image-line" style={{backgroundImage: `url(${"img/ram.jpg"})`}}></section>
                <div className='dati-line'> 
                    <div>Descrizione: Corsair Vengeance 32GB (2x16GB) DDR5 DRAM 5600MT/s C36 AMD EXPO</div>
                    <div>Codice fornitore: VLX0AE66D7</div>
                    <div>Codice produttore: CMH32GX5M2B5600Z36</div>
                    <div>Prezzo: 131 €</div>
                    <div>Quantità: 1</div>
                </div>
            </div>

        </div>

    )
}

function OrderDetail() {
    return (
        <div className='order-container'>
            <div className='detail-container'>
                <div className='order-details'>
                    <div className='dati-base'>
                        <h2>Dettaglio ordine</h2>
                        <h3>Ordine numero: 213121</h3>
                        <h3>Ricevuto il: 28/07/2023</h3>
                    </div>
                </div>
                <div className='order-state'>
                    <div className='order'>
                        <div className='dati-gestione'>
                            <h2>Stato ordine</h2>
                            <h3>Stato: Evaso</h3>
                            <div class="wrapper">
                                <div class="margin-area">
                                    <div class="dot one">1</div>
                                    <div class="dot two">2</div>
                                    <div class="dot three">3</div>
                                    <div class="dot four">4</div>
                                    <div class="progress-bar first"></div>
                                    <div class="progress-bar second"></div>
                                    <div class="progress-bar third"></div>
                                    <div class="message message-1">Ricevuto<br/>01/07/2023</div>
                                    <div class="message message-2">Gestito<br/>02/07/2023</div>
                                    <div class="message message-3">Evaso<br/>07/07/2023</div>
                                    <div class="message message-4">Completato<br/></div>
                                </div>
                            </div>
                            <OrderProducts/>
                        </div>
                    </div>
                </div>
            </div>
            <div className='order-total'>
                <div className='order'>
                    <div className='dati-totale'>
                        <h2>Totale ordine</h2>
                        <section>
                            <p>Totale no iva:</p>
                            <p>650.00 €</p>
                        </section>
                        <section>
                            <p>Spedizione:</p>
                            <p>0.00 €</p>
                        </section>
                        <section>
                            <p>Iva:</p>
                            <p>22%</p>
                        </section>
                        <section>
                            <p><b>Totale ivato:</b></p>
                            <p>800.00 €</p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

function OrderStatus() {
    return (
    <div className="order-status">
        <h1>Controllo stato ordine</h1>
        <h3>Inserisci il codice ricevuto via mail</h3>
        <div className='input-button'>
            <input placeholder='codice...'></input>
            <button >Controlla stato</button>
        </div>
        <OrderDetail />
    </div>
    )
}

export default OrderStatus